
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.5 12a3.751 3.751 0 0 1 3.124-3.7.749.749 0 0 0 .626-.739V5.25a1.5 1.5 0 0 0-1.5-1.5H2.25a1.5 1.5 0 0 0-1.5 1.5v2.313a.749.749 0 0 0 .626.739 3.751 3.751 0 0 1 0 7.4.75.75 0 0 0-.626.739v2.309a1.5 1.5 0 0 0 1.5 1.5h19.5a1.5 1.5 0 0 0 1.5-1.5v-2.313a.749.749 0 0 0-.626-.739A3.751 3.751 0 0 1 19.5 12ZM12 9h5.25","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M13.5 14.625a1.875 1.875 0 1 0 3.75 0 1.875 1.875 0 1 0-3.75 0Zm-6-6.75a.375.375 0 1 1 .375.375.375.375 0 0 1-.375-.375m0 4.5a.375.375 0 1 1 .375.375.375.375 0 0 1-.375-.375m0 4.5a.375.375 0 1 1 .375.375.375.375 0 0 1-.375-.375","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    